import { useState } from "react"
import InplayTodayTomorrowTabs from "./InplayTodayTomorrowTabs";
import SportMatchList from "./SportMatchList";
import { useSelector } from "react-redux";
import CasinoHome from "../../components/CasinoHome";

function Inplay() {
  const [activeTab, setActiveTab] = useState("Inplay");
  const cricketMatches = useSelector(state => state.matches.cricket.matches.data);
  const tennisMatches = useSelector(state => state.matches.tennis.matches.data);
  const soccerMatches = useSelector(state => state.matches.soccer.matches.data);


  return (
    <div className="w-full flex flex-col pb-8"
      style={{ maxHeight: "calc(100vh - 56px - 56px)", overflowY: "auto" }}
    >
      <InplayTodayTomorrowTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <SportMatchList sportId={4} filter={activeTab} sportTitle="Cricket" matchesList={cricketMatches} />
      <SportMatchList sportId={2} filter={activeTab} sportTitle="Tennis" matchesList={tennisMatches} />
      <SportMatchList sportId={1} filter={activeTab} sportTitle="Soccer" matchesList={soccerMatches} />
      <CasinoHome />
    </div>
  )
}

export default Inplay
